import moment from "moment";

const formattedDate = (date, includeTime) => {
  const format = includeTime ? "DD/MM/YYYY h:mm a" : "DD/MM/YYYY";
  return moment(date || new Date()).format(format);
};

const formattedTime = (date, isAmPm) => {
  const format = isAmPm ? "h:mm a" : "h:mm";
  return moment(date || new Date()).format(format);
};

function calculatePackageDuration(startDate, endDate) {
  const currentDate = new Date();

  const start = new Date(startDate);
  const end = new Date(endDate);

  if (currentDate < start) {
    console.log("The package hasn't started yet.");
    return "Not start yet";
  }

  const timeDiff = end - currentDate;

  if (timeDiff < 0) {
    console.log("The package has already expired.");
    return "Expired";
  }

  const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
  const hours = Math.floor(timeDiff / (1000 * 60 * 60));
  const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((timeDiff % (1000 * 60)) / 1000);

  return { days, hours, minutes, seconds };
}

const getCurrentWeek = () => {
  const current = new Date();
  const week = [];

  // Set date to Monday of the current week
  current.setDate(current.getDate() - current.getDay() + 1);
  for (let i = 0; i < 7; i++) {
    week.push(new Date(current));
    current.setDate(current.getDate() + 1);
  }
  return week;
};

function generateEndDatePayload(days) {
  const currentDate = new Date();

  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  let endDate = new Date(currentDate);
  endDate.setDate(currentDate.getDate() + days);

  endDate.setDate(endDate.getDate() - 1);

  endDate = formatDate(endDate);

  return endDate;
}

function getStatus(timeObject) {
  const { days, hours, minutes, seconds } = timeObject;

  if (days === "00" && hours === "00" && minutes === "00" && seconds === "00") {
    return {
      status: "Completed",
      color: "yellow",
    };
  }

  return {
    status: "Current",
    color: "green",
  };
}

function calculateFinalAmount(tax, price, discount) {
  const validTax = Math.min(Math.max(Number(tax) || 0, 0), 100);
  const validPrice = Number(price) || 0;
  const validDiscount = Math.min(Math.max(Number(discount) || 0, 0), 100);

  const taxAmount = (validTax / 100) * validPrice;
  const discountAmount = (validDiscount / 100) * validPrice;

  const finalAmount = validPrice + taxAmount - discountAmount;

  return Math.round(finalAmount);
}

function convertAndCreateDate(isoDateStr) {
  const dateObj = new Date(isoDateStr);
  // dateObj.setMonth(sdateObj.getMonth() - 1); // Subtract a month

  return new Date(
    dateObj.getFullYear(),
    dateObj.getMonth(),
    dateObj.getDate(),
    dateObj.getHours(),
    dateObj.getMinutes()
  );
}
// accoding to ISO app

// function convertAndCreateDate(isoDateStr) {
//   const momentDate = moment.utc(isoDateStr); // Parse as UTC
//   console.log(momentDate.toDate(), "Moment UTC Date");

//   return new Date(
//     momentDate.year(),
//     momentDate.month(),
//     momentDate.date(),
//     momentDate.hour(),
//     momentDate.minute()
//   );
// }

const calculateEndTime = (startTime, totalMinutes) => {
  let hours, minutes, period;

  if (startTime.includes(" ")) {
    //
    const startTimeParts = startTime.split(" ");
    const timeParts = startTimeParts[0].split(":");
    hours = parseInt(timeParts[0], 10);
    minutes = parseInt(timeParts[1], 10);
    period = startTimeParts[1];
  } else {
    const timeParts = startTime.split(":");
    hours = parseInt(timeParts[0], 10);
    minutes = parseInt(timeParts[1], 10);
    period = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;
  }

  const formattedStartMinutes = minutes < 10 ? `0${minutes}` : minutes;
  const formattedStartTime = `${hours}:${formattedStartMinutes} ${period}`;

  let endHours = hours;
  let endMinutes = minutes + totalMinutes;

  if (endMinutes >= 60) {
    endHours += Math.floor(endMinutes / 60);
    endMinutes = endMinutes % 60;
  }

  endHours = (endHours + (period === "PM" && hours !== 12 ? 12 : 0)) % 24;
  const endPeriod = endHours >= 12 ? "PM" : "AM";
  endHours = endHours % 12 || 12;

  const formattedEndMinutes = endMinutes < 10 ? `0${endMinutes}` : endMinutes;
  const endTime = `${endHours}:${formattedEndMinutes} ${endPeriod}`;

  return `${formattedStartTime} - ${endTime} (${Math.floor(
    totalMinutes / 60
  )} hour and ${totalMinutes % 60} mins duration)`;
};
const checkAndReturnArray = (array) => {
  if (array.length === 0) return [];

  let tempArr = [];
  let uniqueIDs = new Set();

  array.forEach((item) => {
    if (!uniqueIDs.has(item.teamMemberID)) {
      uniqueIDs.add(item.teamMemberID);
      tempArr.push(item);
    }
  });

  return tempArr;
};

const generateTimeOptions = () => {
  const options = [];
  const maxMinutes = 180;

  for (let minutes = 5; minutes <= maxMinutes; minutes += 5) {
    let label = "";

    if (minutes < 60) {
      label = `${minutes} min`;
    } else {
      const hours = Math.floor(minutes / 60);
      const remainingMinutes = minutes % 60;
      label =
        remainingMinutes === 0
          ? `${hours} hour`
          : `${hours} hour ${remainingMinutes} min`;
    }

    options.push({ value: minutes.toString(), label });
  }

  return options;
};

const formatDuration = (totalMinutes) => {
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  if (hours > 0) {
    return `${hours} hour${hours > 1 ? "s" : ""} ${
      minutes > 0 ? `${minutes} min${minutes > 1 ? "s" : ""}` : ""
    }`;
  } else {
    return `${minutes} min${minutes > 1 ? "s" : ""}`;
  }
};
export {
  formatDuration,
  getStatus,
  formattedDate,
  generateTimeOptions,
  formattedTime,
  generateEndDatePayload,
  calculatePackageDuration,
  convertAndCreateDate,
  getCurrentWeek,
  calculateFinalAmount,
  checkAndReturnArray,
  calculateEndTime,
};
